// extracted by mini-css-extract-plugin
export default {"root":"Conversation_root__rQtXX","container":"Conversation_container__N6z8m","chatContainer":"Conversation_chatContainer__AfOLR"};